var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as invoiceAction from '../actions/invoice.action';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { InvoiceService } from '../../invoice.service';
var InvoiceEffects = /** @class */ (function () {
    function InvoiceEffects(actions, invoiceService, store) {
        var _this = this;
        this.actions = actions;
        this.invoiceService = invoiceService;
        this.store = store;
        this.getAllInvoices = this.actions.ofType(invoiceAction.GET_ALL_INVOICES)
            .pipe(switchMap(function () {
            return _this.invoiceService.getAllInvoices()
                .map(function (res) {
                res.map(function (i) { return _this.updateMarkPaid(i); });
                return new invoiceAction.GetAllInvoicesSuccess(res);
            })
                .catch(function (error) { return of(new invoiceAction.GetAllInvoicesError(error)); });
        }));
        this.updateInvoice = this.actions.ofType(invoiceAction.UPDATE_INVOICE)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.invoiceService.updateInvoice(body)
                .map(function (res) {
                return new invoiceAction.UpdateInvoiceSuccess(_this.updateMarkPaid(res));
            })
                .catch(function (error) { return of(new invoiceAction.UpdateInvoiceError(error)); });
        }));
        this.approveInvoice = this.actions.ofType(invoiceAction.APPROVE_INVOICE_PAYMENT)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.invoiceService.approveInvoice(body)
                .map(function (res) { return new invoiceAction.ApproveInvoicePaymentSuccess(res); })
                .catch(function (error) { return of(new invoiceAction.ApproveInvoicePaymentError(error)); });
        }));
    }
    InvoiceEffects.prototype.updateMarkPaid = function (i) {
        if (i.markAsPaid === true) {
            i.invoicePaid = 'true';
        }
        if (!i.brandApproval) {
            i.invoicePaid = 'before';
        }
        if (i.markAsPaid === false && i.brandApproval === true) {
            i.invoicePaid = 'admin';
        }
        if (i.markAsPaid === false && i.brandApproval === true && i.pending === true) {
            i.invoicePaid = 'pending';
        }
        if (i.brandApproval === false && i.markAsPaid === false) {
            i.invoicePaid = 'false';
        }
        return i;
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], InvoiceEffects.prototype, "getAllInvoices", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], InvoiceEffects.prototype, "updateInvoice", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], InvoiceEffects.prototype, "approveInvoice", void 0);
    return InvoiceEffects;
}());
export { InvoiceEffects };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/store/effects/invoice.effect.ts.pre-build-optimizer.js